import axios from "./index";
import { buildAuthRedirectPath } from "../shared/utils/authRedirect";

let responseInterceptorId = null;

export const setupAuthzInterceptors = ({ router, store }) => {
  if (responseInterceptorId !== null) {
    return () => {
      if (responseInterceptorId !== null) {
        axios.interceptors.response.eject(responseInterceptorId);
        responseInterceptorId = null;
      }
    };
  }

  responseInterceptorId = axios.interceptors.response.use(
    response => response,
    error => {
      const status = error?.response?.status;
      if (status !== 403) {
        return Promise.reject(error);
      }

      store.dispatch("showAuthzError");

      const homeUrl = store.getters.currentDoctor?.homeUrl || "/";
      const hasAuthFlag = Boolean(router.currentRoute?.value?.query?.__auth);
      const redirectPath = buildAuthRedirectPath(homeUrl, hasAuthFlag);
      router.replace(redirectPath);

      return Promise.reject(error);
    }
  );

  return () => {
    if (responseInterceptorId !== null) {
      axios.interceptors.response.eject(responseInterceptorId);
      responseInterceptorId = null;
    }
  };
};

export { buildAuthRedirectPath };
